module.exports = __webpack_public_path__ + "static/media/nip_collapse.8023e266.svg";